import React from "react";
import WhyChooseUs from "../UI/WhyChooseUs";

const WhyChooseUsPlan = () => {
    const features = [
      
        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fwhy_choose_us%2FEnd_to_End_Support.png?alt=media&token=49b73b91-c5a4-4255-8d42-a46e23dda92f",
            title: "End-to-End Support",
            description: "",
        },

        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fwhy_choose_us%2FExpert_Consultation.png?alt=media&token=ca82cc33-e0bf-417e-bfb5-9be06bf99e75",
            title: "Expert  Consultation",
            description: "",
        },
        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fwhy_choose_us%2FCode_Compliance.png?alt=media&token=f595ce9b-ea00-466f-8a94-19a2be608074",
            title: "Code Compliance",
            description:
                "",
        },
        
        {
            icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fwhy_choose_us%2FQuick_Documentation.png?alt=media&token=ca97c802-3cfe-4e9a-9f87-14c1aa52b209",
            title: "Quick Documentation",
            description: "",
        },
        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2Fwhy_choose_us%2FRegulatory_Liaison.png?alt=media&token=9ba79d29-84a9-44fc-8ea3-3e13a3220e38",
            title: "Regulatory Liaison",
            description: "",
        },
    ];

    return (
        <>
            <WhyChooseUs features={features} />
        </>
    );
};

export default WhyChooseUsPlan;
